<script setup>
// Etiquetas da CONVERSA. A lista antiga era `absolute` dentro da ficha e
// ficava cortada perto do fim da tela (16/09/2026) — agora usa o mesmo
// seletor da etiqueta do contato, preso à tela.
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useMapGetter } from 'dashboard/composables/store';
import { useConversationLabels } from 'dashboard/composables/useConversationLabels';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import SeletorDeEtiquetas from 'dashboard/components-next/label/SeletorDeEtiquetas.vue';
import ChipDeEtiqueta from 'dashboard/components-next/label/ChipDeEtiqueta.vue';
import EsqueletoLista from 'dashboard/components-next/EsqueletoLista.vue';
import AddLabelModal from 'dashboard/routes/dashboard/settings/labels/AddLabel.vue';

const { t } = useI18n();
const { isAdmin } = useAdmin();
const {
  savedLabels,
  activeLabels,
  accountLabels,
  addLabelToConversation,
  removeLabelFromConversation,
} = useConversationLabels();
const uiFlags = useMapGetter('conversationLabels/getUIFlags');

const seletor = ref(null);
const nomeNovo = ref('');
const criando = computed(() => Boolean(nomeNovo.value));

// A falha já vira aviso dentro do composable (dispatchWithAlert).
const alternar = etiqueta =>
  savedLabels.value.includes(etiqueta.title)
    ? removeLabelFromConversation(etiqueta.title)
    : addLabelToConversation(etiqueta);

useKeyboardEvents({
  KeyL: {
    action: e => {
      e.preventDefault();
      seletor.value?.alternarLista();
    },
  },
});
</script>

<template>
  <EsqueletoLista
    v-if="uiFlags.isFetching"
    :linhas="1"
    :altura="24"
    :rotulo="t('LABEL.TAG_BUTTON')"
  />
  <div v-else class="lbx">
    <!-- Etiqueta removida recolhe no lugar (24/10/2026); a saída mora no chip. -->
    <TransitionGroup name="cde">
      <ChipDeEtiqueta
        v-for="label in activeLabels"
        :key="label.id"
        :etiqueta="label"
        @remover="alternar"
      />
    </TransitionGroup>
    <SeletorDeEtiquetas
      ref="seletor"
      :etiquetas="accountLabels"
      :escolhidas="savedLabels"
      :pode-criar="isAdmin"
      :rotulo="t('CONVERSATION_SIDEBAR.ACCORDION.CONVERSATION_LABELS')"
      @alternar="alternar"
      @criar="nomeNovo = $event"
    />
    <woot-modal :show="criando" :on-close="() => (nomeNovo = '')">
      <AddLabelModal :prefill-title="nomeNovo" @close="nomeNovo = ''" />
    </woot-modal>
  </div>
</template>

<style scoped>
.lbx {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--esp-1);
}
</style>
